import Header from './parts/Header'
import PrintTypes from './parts/PrintTypes'
import { PrintType } from '@/features/print/constants'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface ContentProps {
    printerName: string | null
    printTypes: PrintType[]
}

const Content: FC<ContentProps> = ({ printerName, printTypes }) => {
    return (
        <View style={styles.container}>
            <Header printerName={printerName} />
            <PrintTypes printTypes={printTypes} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 12,
        maxWidth: '100%',
    },
})

export default Content
